const AUTH_RESPONSE_PATTERN = /[#?&](code|error)=/;
const STATE_PATTERN = /[#?&]state=/;

/**
 * True when this page is MSAL's hidden silent-renewal iframe landing on the
 * redirectUri with an auth response. MSAL 5 does not read the iframe's URL
 * itself; the page must broadcast the response back or renewal times out
 * (redirect_bridge_timeout) and the user is logged out.
 *
 * Top-level redirect logins are excluded — handleRedirectPromise owns those.
 */
export const isMsalSilentRenewalFrame = (win: Window = window): boolean => {
    if (win.self === win.top) return false;
    const response = `${win.location.hash}${win.location.search}`;
    return AUTH_RESPONSE_PATTERN.test(response) && STATE_PATTERN.test(response);
};
